export const serviceSpgc = [
  {
    name: 'Gás Canalizado',
    url: '/gas-canalizado',
    external: false,
    list: [
      {
        name: 'Solicitação de Autorização para o Mercado Livre de Gás',
        url: '/solicitacao',
        icon: 'assignment_add',
        external: false,
      },
      {
        name: 'Consulta de Solicitação',
        url: '/consultar-solicitacao',
        icon: 'plagiarism',
        external: false,
      },
    ],
  },
];
